import { t } from '@lingui/macro';
import * as yup from 'yup';

import primaryContactValidationSchema from './primaryContactValidations';

const depotValidationSchema = yup
  .object({
    accountId: yup.string(),
    dmsId: yup
      .string()
      .max(40, t`FMS ID must be at most 40 characters`)
      .matches(
        /^([a-zA-Z0-9]([a-zA-Z0-9 ]*[a-zA-Z0-9])?)?$/,
        t`FMS ID must contain only letters, numbers, and spaces, with no leading or trailing spaces`,
      ),
    note: yup.string().max(1000, t`Notes must be at most 1000 characters`),
    name: yup.string().required(t`Name is required`),
    email: yup
      .string()
      .email(t`Invalid email format`)
      .required(t`Email is required`),
    address: yup.string(),
    city: yup.string().required(t`City is required`),
    state: yup.string().required(t`State is required`),
    postalCode: yup.string(),
    country: yup.string().required(t`Country is required`),
  })
  .required();

const validationSchema = depotValidationSchema.concat(
  primaryContactValidationSchema,
);

export default validationSchema;
